import CatalogTop from '~/themes/base/components/catalog/CatalogTop'

export default {
  extends: CatalogTop,
}
